import { render, staticRenderFns } from "./YoutubeIframe.vue?vue&type=template&id=b79964d4&"
import script from "./YoutubeIframe.vue?vue&type=script&lang=js&"
export * from "./YoutubeIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports